// Utility to generate a URL-safe path for stock price pages

/**
 * Converts a string to URL-safe kebab-case (lowercase, spaces and special chars replaced with hyphens)
 */
function toUrlSafeName(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric with hyphen
    .replace(/^-+|-+$/g, '')     // Trim leading/trailing hyphens
    .replace(/--+/g, '-');       // Replace multiple hyphens with one
}

/**
 * Generates a URL for a stock price page: /stocks/{stock-name}/
 * Accepts a stock object with a name property, or a string name.
 */
export function generateStockUrl(stock: { name: string } | string): string {
  const name = typeof stock === 'string' ? stock : stock.name;
  return `/stocks/${toUrlSafeName(name)}/`;
} 